import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import { getValue } from "@utils/lodash";
import "./pagination.scss";

export default function PaginationPage(props: any) {
  const [options, setOptions] = useState<any>([]);
  useEffect(() => {
    let option = [];
    let count = props?.limitToFifty ? 6 : 11;

    for (let i = 0; i < count; i++) {
      if (i) option.push(i * 10);
    }
    setOptions(option);
  }, []);

  return (
    <section
      className="pagination-wrapper d-flex align-items-center justify-content-between w-100"
      // style={{marginLeft:getValue(props, `optimize`, "") === "false"?'20px':''}}
    >
      <div className="show-rows d-flex align-items-center">
        <p className="show-rows-count fw-medium-bold">
          Total Count - <span>{props.totalCount}</span>
        </p>
      </div>
      <div className="d-flex justify-content-between align-items-center">
        {getValue(props, `showLimit`, "") !== "false" &&
          getValue(props, `hideRowsPerPage`, false) !== true && (
          <>
            {getValue(props, `optimize`, "") === "false" ? (
              ""
            ) : (
              <p className="show-rows-count">Rows per page:</p>
            )}
            <span className="show-select-dd-wrapper">
              <select
                className="show-select"
                onChange={(e) => props.handleChangeLimit(e.target.value)}
              >
                {options.map((item: number) => {
                  return (
                    <option selected={item == props.limit} value={item}>
                      {item}
                    </option>
                  );
                })}
              </select>
            </span>
          </>
        )}

        {/* <p className="ms-3 go-to-page show-rows-count">Go to page:</p>
					<input type="text" className="form-control single-border" value={`05`} /> */}
        {getValue(props, `showLimit`, "") !== "false" && (
          <div className="show-count mx-4">
            {getValue(props, `pageNumber`, 0)} -{" "}
            {Math.ceil(
              getValue(props, `totalCount`, 0) / getValue(props, `limit`, 1)
            )}{" "}
            of{" "}
            {Math.ceil(
              getValue(props, `totalCount`, 0) / getValue(props, `limit`, 1)
            )}
          </div>
        )}

        <div>
          <Pagination
            activePage={props.pageNumber}
            itemsCountPerPage={props.limit}
            totalItemsCount={props.totalCount}
            pageRangeDisplayed={5}
            onChange={props.handleChangePagination}
          />
        </div>
      </div>
    </section>
  );
}
